import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
 selector: 'formly-blurb',
 template: `
   <app-blurb [message]="props.label"></app-blurb>
 `,
})
export class FormlyBlurbComponent extends FieldType {
}
